import classNames from 'classnames';
import React from 'react';

import Link, { navigateTo } from 'gatsby-link';

/**
 * Returns `true` if the two paths are the same.
 */
const isSamePath = (path1, path2) => {
    if (!path1 || !path2) {
        return false;
    }
    path1 = path1.split('#')[0];
    path2 = path2.split('#')[0];

    return path1 === path2;
};

class NavLink extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    };

    /**
     * Implements a click handler for processing click events on
     * links. Specifically, handles anchor link and prevents the page from jumping
     * on click.
     */
    handleClick(e) {
        if (this.props.onClick) {
            this.props.onClick(e);
        }

        // If the paths are the same, then prevent the default click from going
        // through (so we don't jump to the anchor), and then programatically
        // navigate to the `to` URL so the router's `onUpdateRoute` function picks
        // up on the URL and scrolls to the appropriate location.
        if (isSamePath(window.location.pathname, this.props.to)) {
            e.preventDefault();
            navigateTo(this.props.to);
        }
    };


    render() {
        if (this.props.to.startsWith('/')) {
            return (
                <Link {...this.props}
                      className={classNames('nav-link', this.props.className)}
                      onClick={this.handleClick}>
                    {this.props.children}
                </Link>
            );
        }

        return (
            <a {...this.props}
               href={this.props.to}
               className={classNames('nav-link', this.props.className)}>
                {this.props.children}
            </a>
        );
    }
}

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/NavLink.js